import { Theme } from '@portal-shared/app/models/theme.model';

export const DarkTheme: Theme = {
  selector: 'dark-theme',
  name: 'Dark'
};
